define([
    "./hereMapsModule"
], function (hereMapsModule) {
    "use strict";

    return hereMapsModule.service("hereMapsService", [
        function () {
            var map = null;
            var here = null;
            var behavior = null;
            var ui = null;

            return {
                register: register,
                getMap: getMap,
                getHere: getHere,
                getBehavior: getBehavior,
                getUi: getUi,
                clear: clear
            };

            function register(data) {
                map = data.map;
                here = data.here;
                behavior = data.behavior;
                ui = data.ui;

            }

            function getMap() {
                return map;
            }

            function getHere() {
                return here;
            }

            function getBehavior() {
                return behavior;
            }

            function getUi() {
                return ui;
            }

            function clear() {
                map = null;
                here = null;
                behavior = null;
                ui = null;
            }
        }
    ]);
});